import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { usePageVisibility } from '../../common/usePageVisibility';
import { api } from '../../utils/api-client';

export const MATCHING_QUERY_KEY = 'candidate-project-matching';

// List and detail reads share visibility, recovery, polling, and invalidation.
export const useMatchingRead = <T extends { processingActive: boolean }>(
  key: readonly unknown[],
  url: string,
  active: boolean,
  params?: URLSearchParams
) => {
  const visible = usePageVisibility();
  const enabled = active && visible;
  return useQuery<T, AxiosError<{ messages?: Record<string, string> }>>(
    [MATCHING_QUERY_KEY, ...key],
    async () => (await api.get<T>(url, params ? { params } : undefined)).data,
    {
      enabled,
      staleTime: 0,
      retry: false,
      refetchOnWindowFocus: false,
      refetchInterval: (data, query) => (enabled && !query.state.error && data?.processingActive ? 15000 : false),
      refetchIntervalInBackground: false,
    }
  );
};
